export default __webpack_public_path__ + "static/media/banners_4.b6f6c01c.png";